/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import isPropValid from '@emotion/is-prop-valid';
import { MenuList } from '@reach/menu-button';
import styled from '@emotion/styled/macro';

import { Box } from 'components/styled';
import { resetButtonStyle } from 'components/styled/Button';

export const StyledMenuList = styled(MenuList)`
	padding: 0;
	margin-top: ${p => p.theme.space[2]}px;
	font-size: ${p => p.theme.fontSizes.sm}px;
	border: 1px solid ${p => p.theme.colors.primary};
	background: #ffffff;
	border-radius: 3px;
	max-width: 60vw;
	margin-right: ${p => p.theme.space[4]}px;

	& [data-reach-menu-item] {
		padding: ${p => p.theme.space[2]}px ${p => p.theme.space[3]}px;
	}

	& [data-reach-menu-item][data-selected] {
		background: ${p => p.theme.colors.primaryLight};
		color: #000000;
	}

	:focus {
		box-shadow: none;
	}
`;

export const MenuHeader = styled.div`
	background: ${p => p.theme.colors.primary};
	color: #ffffff;
	font-weight: bold;

	&[data-reach-menu-item][data-selected] {
		background: ${p => p.theme.colors.primary};
		color: #ffffff;
	}
`;

export const MenuAvatar = styled(Box, {
	shouldForwardProp: isPropValid,
})<{ isOpen?: boolean; disabled?: boolean; border?: boolean }>`
	${resetButtonStyle}

	padding: 0;
	border-radius: 50%;
	overflow: hidden;
	width: 40px;
	height: 40px;
	flex-shrink: 0;
	display: flex;
	justify-content: center;
	align-items: center;

	${p =>
		p.border &&
		css`
			border: 1px solid ${p.theme.colors.darkerGrey};
			width: 41px;
			height: 41px;
		`}

	${p =>
		p.disabled &&
		css`
			color: ${p.theme.colors.darkerGrey};
		`}

	${p =>
		!p.disabled &&
		css`
			color: ${p.isOpen ? p.theme.colors.darkerGrey : 'black'};

			&:hover,
			&:focus {
				background-color: ${p.theme.colors.primaryLight};
			}
		`}
`;
